import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "9.5", x2: "14.5", y1: "9", y2: "14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14.5", x2: "9.5", y1: "9", y2: "14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ShieldClose";
const ShieldClose = memo(themed(Icon));
export {
  ShieldClose
};
//# sourceMappingURL=shield-close.js.map
